module.exports = __webpack_public_path__ + "static/img/9e4e78ee.svg";